import {createAnalyticsEvent, getAnalyticsV2Proxy, submitV2AnalyticsEvent} from "../utils/analyticsUtils";
import {getCookieCustomerNumber, getCookieUserId} from "../utils/cookieUtils";
import jsonSearchTermFile from "../../../../resources/misc/insights.json";
import {isMaxUser} from "../utils";

export const getCurrentListFromLocalStorage = () => {
    const key = `lastListInSession_${getCookieUserId()}_${getCookieCustomerNumber()}`
    const item = window && window.localStorage && window.localStorage.getItem(key)

    return item ? JSON.parse(item) : null
}

const getCartState = () => {
    const lastListInSession = getCurrentListFromLocalStorage()
    const listType = lastListInSession && lastListInSession.listType

    switch (listType) {
        case "CART":
            return "Standard Cart"
        case "QUOTING_TOOL":
            return "Quoting Tool"
        case "QUOTES":
            return "Quotes"
        case "PRODUCT_LIST":
            return "Product Lists"
        case "ORDERS":
            return "Orders"
        case "PUNCHOUT":
            return "Punchout"
        default:
            null
    }
}

const storeSearchTermsToSession = () => {
    const key = `searchTermsMap_${getCookieUserId()}`
    const searchTermsMap = window && window.sessionStorage && window.sessionStorage.getItem(key)

    if (searchTermsMap == null) {
        const searchTermArray = [];
        for(let i = 0; i < 1000; i++) {
            const item = jsonSearchTermFile[i];
            searchTermArray.push(item.searchTerm.toLowerCase());
        }
        window && window.sessionStorage && window.sessionStorage.setItem(key, JSON.stringify(searchTermArray));
    }
}

export const initSearchAnalytics = () => {
    const searchBarMenuDisplayed = document.querySelector('#search-results').style.display.toLowerCase() === 'block' ? "Yes" : "No";
    if (window && window.location && window.location.search) {
        const maxUser = isMaxUser(window);
        console.log("isMaxUser: " + maxUser);

        const searchTerm = new URLSearchParams(window.location.search).get("query");

        storeSearchTermsToSession();
        const key = `searchTermsMap_${getCookieUserId()}`;
        const searchTermsMap = window && window.sessionStorage && window.sessionStorage.getItem(key);
        const searchTermsArray = JSON.parse(searchTermsMap);

        if (searchTerm) {
            console.log("searchMenuDisplayed: " + searchBarMenuDisplayed);

            submitV2AnalyticsEvent("submitProductSearch", {
                searchTerm,
                searchBarMenuDisplayed: searchBarMenuDisplayed
            });

            submitV2AnalyticsEvent("submitProductSearch", {
                cartState: getCartState(),
                augmented: searchTermsArray.some(element => element === searchTerm.toLowerCase())
            });

            document.querySelectorAll('.search-result__section').forEach(section => {
                const title = section.querySelector('.search-result__section-title').textContent.trim();
                const list = section.querySelector('ul');

                list.addEventListener('click', (event) => {
                    const clickedValue = event.target.textContent.trim();
                    let searchMethod = '';

                    if (title === 'Categories') {
                        searchMethod = 'Categories';
                    } else if (title === 'Suggested search') {
                        searchMethod = 'Suggested search';
                    } else if (title === 'Related Products') {
                        searchMethod = 'Related products';
                    }

                    if (searchMethod) {
                        submitV2AnalyticsEvent("submitProductSearch", {
                            searchMethod,
                            value: clickedValue
                        });
                        console.log("searchMethod: " + searchMethod + " value: " + clickedValue);
                    }
                });
            });

            document.body.addEventListener('click', (event) => {
                console.log("clicked: ", event.target);
                console.log("isMaxUser: ", isMaxUser(window));
                if (event.target.matches('.header-main__search-button--results') && isMaxUser(window)) {
                    const event = createAnalyticsEvent("submitProductSearch", {
                        searchMethod: "Show all results"
                    });
                    getAnalyticsV2Proxy().push(event);
                    console.log("Analytics event: ", event);
                    console.log("isMaxUser in if statement: ", isMaxUser(window));
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./javascript/product-search-page/search-analytics/searchAnalytics.js